import {
  POST_ADD_MODULE_2W,
  GET_TUTORIAL_DETAILS_2W,
  GET_TUTORIAL_LIST_2W,
  POST_EDIT_MODULE_2W,
  GET_MODULE_LIST_2W,
  FETCH_MODULE_BY_ID_2W,
  DELETE_CONTENT_2W,
  DELETE_MODULE_2W,
  GET_TRAINING_CATEGORY_LIST,
} from '../actions/types';

const initialState = {
  loading: false,
  userList: [],
  error: null,
  isAddingModule: false,
  isEditingModule: false,
  tutorialDetails2w: {},
  tutorialList2w: [],
  moduleList: [],
  trainingCategories: [],
};

const module2wReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TUTORIAL_LIST_2W:
      return {
        ...state,
        tutorialList2w: action.payload?.data?.data?.results ?? [],
      };

    case GET_TUTORIAL_DETAILS_2W:
      return {
        ...state,
        tutorialDetails2w: action.payload,
      };

    case DELETE_CONTENT_2W:
      return {
        ...state,
        tutorialList2w: state.tutorialList2w.filter(item => item.id !== action.payload.id),
      };

    case GET_MODULE_LIST_2W:
      return {
        ...state,
        moduleList: action.payload,
      };

    case FETCH_MODULE_BY_ID_2W:
      return {
        ...state,
        moduleDetail: action.payload,
      };

    case POST_ADD_MODULE_2W:
      return {
        ...state,
        isAddingModule: false,
        userList: [...state.userList, action.payload.module],
      };

    case POST_EDIT_MODULE_2W:
      return {
        ...state,
        isEditingModule: false,
        userList: state.userList.map(module =>
          module.id === action.payload?.data?.id ? action.payload?.data : module
        ),
      };

    case DELETE_MODULE_2W:
      return {
        ...state,
        moduleList: Array.isArray(state.moduleList)
          ? state.moduleList.filter(m => m.id !== action.payload.id)
          : state.moduleList,
      };

    case GET_TRAINING_CATEGORY_LIST:
      return {
        ...state,
        trainingCategories: action.payload?.data ?? [],
      };

    default:
      return state;
  }
};

export default module2wReducer;
